import logger from '%app/js/common/services/Logger';

const listeners = new Set();

const subscribeToCookieConsentChange = (listener) => {
    listeners.add(listener);

    return () => {
        listeners.delete(listener);
    };
};

const notifyCookieConsentChange = () => {
    Array.from(listeners).forEach((listener) => {
        try {
            listener();
        } catch (error) {
            logger.warning('cookieConsentChangeNotifier: listener failed', { error });
        }
    });
};

export { subscribeToCookieConsentChange, notifyCookieConsentChange };
